import React, { useEffect, useState } from "react";
import {
  FaPlus,
  FaEllipsisVertical,
  FaEye,
  FaPen,
  FaCopy,
  FaFilter,
  FaArrowLeftLong,
} from "react-icons/fa6";
import { MdDelete, MdSearch, MdRefresh } from "react-icons/md";
import { handleRowsPerPage } from "../../../controls/Pagination/Pagination";
import { capitalizeWords } from "../../../../utils/common";

import { Header, DataTable } from "../../../common";
import {
  ButtonView,
  CardView,
  Input,
  Select,
  ModalView,
  IconMenuOption,
} from "../../../controls";

import "./NotificationActivityLogStyles.scss";
import moment from "moment";
import { history } from "../../../../store/configure/configureStore";

const NotificationActivityLogView = ({
  activityLogList,
  notificationTypeList,
  //
  currentPageOfActivityLog,
  rowsPerPageOfActivityLog,
  persistedData,
  //
  rowsPerPageDropDownOptions,
  //
  handleTableRowsChange,
  handleChangePage,
  //
  fetchPaymentReceipts,
  //
  onClickNotificationTypeMenuFilterOptions,
}) => {
  // console.log("activityLogList", activityLogList);

  const renderNotificationTypeHeader = (label) => {
    return (
      <div className="custom-column-header">
        <text>{label}</text>
        <div className="sortIcon">
          {
            <IconMenuOption
              menuIcon={<FaFilter />}
              options={notificationTypeList}
              name={"type"} //access the value using this prop in iconMenuOption
              search={false} //show search input
              showMenuOptions={true}
              onClickFilterOption={onClickNotificationTypeMenuFilterOptions}
              persistedData={persistedData?.notificationType}
            />
          }
        </div>
        {/* )} */}
      </div>
    );
  };

  const renderOriginalTransactionValue = (row) => {
    const transactionId = row?.receiptInfo?.originalTransactionId;
    const handleCopy = (transactionId) => {
      if (transactionId) {
        navigator.clipboard
          .writeText(transactionId)
          .then(() => {
            console.log("Transaction ID copied to clipboard!"); // Optional feedback for the user
          })
          .catch((err) => {
            console.error("Could not copy text: ", err);
          });
      }
    };

    return (
      <div className="cell-wrapper">
        <span data-tag="allowRowEvents" className={`content-block`}>
          {row?.receiptInfo?.originalTransactionId || "-"}
        </span>
        <span className="action-block">
          <FaCopy
            size={15}
            title="Copy"
            onClick={() => handleCopy(transactionId)}
          />
        </span>
      </div>
    );
  };

  const columns = [
    {
      name: "Title",
      // cell: (row) => renderOriginalTransactionValue(row),
      cell: (row) => row?.notificationId?.title || "-",
      // grow: 1.5,
      width: "40%",
    },
    {
      name: "Description",
      selector: (row) => row?.notificationId?.body || "-",
      // grow: 2,
      width: "40%",
    },
    {
      name: "Created At",
      selector: (row) => moment(row?.createdAt).format("MM-DD-YYYY") || "-",
      // grow: 1,
      width: "20%",
    },
  ];

  // const MyExpander = (props) => (
  //   console.log("props", props)

  //   <div className="expander-row-wrapper">
  //     <div className="wrapper">
  //       <span className="stat-block">5</span>
  //       <span className="content--label_android">Android Send Count</span>
  //     </div>
  //     <div className="wrapper">
  //       <span className="stat-block">10</span>
  //       <span className="content--label_ios">Ios Send Count</span>
  //     </div>
  //   </div>
  // );

  const MyExpander = (props) => {
    return (
      <div className="expander-row-wrapper">
        <div className="wrapper">
          <span className="stat-block">
            {/* {(props.data?.androidSendCount || 0) + (props.data?.iosSendCount || 0) || 0} */}
            {(props.data?.androidSendCount || 0) +
              (props.data?.iosSendCount || 0)}
          </span>
          <span className="content--label_android">Send Count</span>
        </div>
        <div className="wrapper">
          <span className="stat-block">
            {(props.data?.androidOpenCount || 0) +
              (props.data?.iosOpenCount || 0)}
          </span>
          <span className="content--label_ios">Open Clicks</span>
        </div>
      </div>
    );
  };

  const [expandedRowId, setExpandedRowId] = useState(null);

  useEffect(() => {
    //reset expanded row when page change
    setExpandedRowId(null);
  }, [currentPageOfActivityLog]);

  const handleRowClick = (row) => {
    // Collapse previously expanded row if the same is clicked again
    setExpandedRowId((prevId) => (prevId === row._id ? null : row._id));
  };

  const isRowExpanded = (row) => expandedRowId === row._id;

  return (
    <div className="activity__log--container">
      <div className="activity__log--header-wrapper">
        <div className="action">
          <FaArrowLeftLong size={25} onClick={() => history?.goBack()} />
        </div>
        <div className="title-content">Notification Activity Log</div>
      </div>
      <div className="activity__log--table-wrapper">
        <div className="controls-wrapper">
          <div className="row-control-wrapper">
            <Select
              value={rowsPerPageOfActivityLog}
              placeholder={10}
              options={rowsPerPageDropDownOptions}
              onChange={(val) => {
                handleTableRowsChange(val);
              }}
              isRowCap={true}
            />{" "}
            entries per page
          </div>
          <div className="row-control-wrapper">
            {/* <ButtonView
              title="Go Back"
              styles={"secondary"}
              // icon={<MdRefresh size={20} />}
              onClick={() => {
                history?.goBack();
              }}
            /> */}
          </div>
        </div>
        <div className="table-content">
          <DataTable
            keyfield={"_id"}
            columns={columns}
            data={activityLogList?.docs || []}
            highlightOnHover={true}
            pointerOnHover={true}
            fixedHeader={true}
            persistTableHead={true}
            //
            pagination={true}
            paginationServer={true}
            paginationPerPage={activityLogList?.limit}
            paginationTotalRows={activityLogList?.totalDocs}
            onChangeRowsPerPage={handleTableRowsChange}
            onChangePage={handleChangePage}
            currentPage={currentPageOfActivityLog}
            //
            expandableRows={true}
            // expandableRowDisabled={expandableRowDisabled}
            expandOnRowClicked={true}
            expandableRowsHideExpander={true}
            expandableRowsComponent={MyExpander}
            expandableInheritConditionalStyles={true}
            onRowClicked={handleRowClick} // Handle row click
            expandableRowExpanded={isRowExpanded} // Manually control which row is expanded
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationActivityLogView;
